/**
 * Internal QA override shared by classic right-rail and full-page CRUD editors.
 * - CRUD URL + `classic` → Meeting Types + classic rail (param not kept on the list URL)
 * - Classic rail + `new` → full-page CRUD
 * - Matching param on the current surface → stay
 */
export const ET_EDITOR_QUERY_PARAM = 'et_editor'

export const ET_EDITOR_VARIANTS = {
  NEW: 'new',
  CLASSIC: 'classic',
} as const

export type EtEditorVariant = (typeof ET_EDITOR_VARIANTS)[keyof typeof ET_EDITOR_VARIANTS]

/** Default tab on `/event_types/:id/editor/:tab` when forcing the CRUD editor. */
export const ET_CRUD_EDITOR_DEFAULT_TAB_KEY = 'meeting-details'
